import { FuelDivider, FuelButton } from '@frete.com/fuel-react'
import { FuelFlex } from '@frete.com/fuel-station-react'
import { useTranslator } from '~hooks'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import { CheckoutFeedbackProps } from './interfaces'
import { useMemo } from 'react'

const FeedbackFooter = ({ type, onCancel, onRetry }: CheckoutFeedbackProps) => {
  const { k, t } = useTranslator()

  const FooterContent = useMemo(() => {
    if (type === 'failure') {
      return (
        <FuelFlex
          defaultProps={{
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            customMargin: `${theme.spacing.km6} 0`,
            customPadding: `0 ${theme.spacing.km8}`,
          }}
        >
          <FuelButton
            data-testid="checkout-feedback-error-retry"
            onClick={() => {
              onRetry?.()
            }}
          >
            {t(k.translation.TRY_AGAIN)}
          </FuelButton>
        </FuelFlex>
      )
    } else {
      return (
        <FuelFlex
          defaultProps={{
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            customMargin: `${theme.spacing.km6} 0`,
            customPadding: `0 ${theme.spacing.km8}`,
            gap: 'km4',
          }}
        >
          <FuelButton variant="tertiary" data-testid="checkout-feedback-error-cancel" onClick={onCancel}>
            {t(k.translation.CANCEL)}
          </FuelButton>
        </FuelFlex>
      )
    }
  }, [type])

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <FuelDivider size="large" />
      {FooterContent}
    </FuelFlex>
  )
}

export default FeedbackFooter
